// removed by extract-text-webpack-plugin
module.exports = {"quizIndicator":"QuizIndicator-cssmodule-quizIndicator-cTPVX","indicator":"QuizIndicator-cssmodule-indicator-19khX"};


//////////////////
// WEBPACK FOOTER
// ./components/CommonSet/QuizIndicator.cssmodule.less
// module id = 640
// module chunks = 0